import { materials as MaterialsService } from '@coligo-org/fe-common/services';
import { ErrorsActions } from '../error';
import logger from '../../../common/services/logService';
import { coursesTypes } from '../../reducers/types';
import getCourseMaterials from './getCourseMaterials';

export const updateFolderStart = () => ({
  type: coursesTypes.UPDATE_MATERIAL_START,
});

export const updateFolderEnd = () => ({
  type: coursesTypes.UPDATE_MATERIAL_END,
});

export default ({ courseId, materialId, folder, callback }) =>
  async dispatch => {
    try {
      dispatch(updateFolderStart());
      await MaterialsService.updateFolder({ materialId, folder });
      if (callback) callback();
    } catch (error) {
      logger.log(error);
      if (error.response) {
        dispatch(ErrorsActions.addError(error.response.data.message));
      }
    } finally {
      dispatch(updateFolderEnd());
      dispatch(getCourseMaterials(courseId));
    }
  };
